import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { updatePartnerUserPreferences } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { useAsync } from 'react-async';
async function updateLinePatternUserPreference(_ref) {
  let [mpacBaseUrl, linePatternPreferenceToUpdate, allUserPreferences] = _ref;
  const result = await updatePartnerUserPreferences(mpacBaseUrl, _objectSpread(_objectSpread({}, allUserPreferences), linePatternPreferenceToUpdate));
  return result;
}
export function useLinePatternUserPreference(_ref2) {
  let {
    mpacBaseUrl,
    initialAllUserPreferences
  } = _ref2;
  const {
    isPending: isUpdateLinePatternUsageUserPreferencePending,
    isRejected: isUpdateLinePatternUsageUserPreferenceRejected,
    run: runUpdateLinePatternUserPreference,
    data: updatedLinePatternsUsageUserPreferences,
    error: userPreferenceUpdateError
  } = useAsync({
    initialValue: initialAllUserPreferences,
    deferFn: updateLinePatternUserPreference
  });
  if (isUpdateLinePatternUsageUserPreferenceRejected) {
    log.error('useLinePatternUserPreference', 'Error updating line pattern usage in charts preference', {
      error: userPreferenceUpdateError
    });
  }
  const handleLinePatternUsagePreferenceChange = preferenceToUpdate => {
    runUpdateLinePatternUserPreference(mpacBaseUrl, {
      isPatternedChart: preferenceToUpdate
    }, updatedLinePatternsUsageUserPreferences);
  };
  return {
    value: updatedLinePatternsUsageUserPreferences.isPatternedChart,
    onPreferenceChange: handleLinePatternUsagePreferenceChange,
    isUpdateLinePatternUsageUserPreferencePending,
    isUpdateLinePatternUsageUserPreferenceRejected
  };
}